import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import { type ReactNode, useState } from "react";

import { NAME_COL_WIDTH, TASK_BLOCK_HEIGHT } from "./constants";
import { type CoWorkerCalendar } from "./types";
import { WorkingHoursModal } from "./working-hours/WorkingHoursModal";

const CoWorkerBlockContainer = styled.div<{
  last?: boolean;
  heightInPx?: number;
}>`
  cursor: pointer;
  position: sticky;
  left: 0;
  padding: 0 5px;
  width: ${NAME_COL_WIDTH}px;

  // Appointment blocks are absolute positioned so this height matches such a block
  ${({ heightInPx }) =>
    heightInPx !== undefined ? `height: ${heightInPx}px` : TASK_BLOCK_HEIGHT};

  z-index: 3;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: ${LightMode.colourStaticWhite};
  border-right: 1px solid ${LightMode.colourNeutral4};
  ${({ last }) =>
    last ? "" : `border-bottom: 1px solid ${LightMode.colourNeutral4};`};
`;

interface Props {
  coWorker?: CoWorkerCalendar;
  last?: boolean;
  heightInPx?: number;

  children: ReactNode;
}
export const CoWorkerBlock = ({
  coWorker,
  last,
  heightInPx,
  children,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <CoWorkerBlockContainer
      last={last}
      heightInPx={heightInPx}
      onClick={() => setIsOpen(true)}
    >
      {children}
      {coWorker && isOpen && (
        <WorkingHoursModal
          isOpen={isOpen}
          closeModal={(e) => {
            e.stopPropagation();
            setIsOpen(false);
          }}
          coWorker={coWorker}
        />
      )}
    </CoWorkerBlockContainer>
  );
};
